import { PDFDocument } from 'pdf-lib'
import fontkit from '@pdf-lib/fontkit'
import { useState } from "react"
import moment from "moment";
import constant from '../../../constant';

interface IPropType {
    detail: {
        loanId: any, borrowerAddress: any,
        borrowerName: any, borrowerEmail: any, borrowerSignature: any, borrowerSignatureDate: any,
        transactionNumber: any, transactionAmount: any, ctcDate: any, broker: any,
        coBorrowerName: any, coBorrowerEmail: any, coBorrowerSignature: any, coBorrowerSignatureDate: any,
    }
}

function HeterIskaPDF(props: IPropType) {
    const { detail } = props;
    const [stateDetail, setStateDetail]: any = useState(null);
    const [docURL, setDocURL]: any = useState(null);

    if (JSON.stringify(detail) !== JSON.stringify(stateDetail)) {
        generateBlob(detail).then((res: any) => {
            const _docURL = URL.createObjectURL(res);
            setDocURL(_docURL);
        })
        setStateDetail(detail);
    }

    if (docURL) {
        return <iframe title="Heter Iska" style={{ width: '100%', height: '100%' }} src={docURL} />
    }
    return <div>Loading...</div>
}

export async function generateBlob(detail: any) {
    const fontURL = '/fonts/calibril.ttf'
    const fontBytes = await fetch(fontURL).then(res => res.arrayBuffer())

    const url = `${process.env.REACT_APP_BASE_URL}/heter-iska/nfty.pdf`;
    const existingPdfBytes = await fetch(url).then(res => res.arrayBuffer())

    const pdfDoc = await PDFDocument.load(existingPdfBytes);
    pdfDoc.registerFontkit(fontkit)
    // disable ligatures: pdf-lib drops/shifts glyphs when fontkit merges pairs like "tt" or "ff"
    const customFont = await pdfDoc.embedFont(fontBytes, { features: { liga: false } })

    const pages = pdfDoc.getPages();
    const fontSize = 10;
    const { height } = pages[3].getSize()

    //#region page 4 - Heter Iska (Exhibit A) header
    const _ctcDate = detail.ctcDate ? moment(detail.ctcDate) : moment();
    // date
    pages[3].drawText(_ctcDate.format(constant.formatting.usDateFormat), { x: 182, y: (height - 180), size: fontSize, font: customFont, });
    // receiver name
    pages[3].drawText(detail.borrowerName || '', { x: 182, y: (height - 194), size: fontSize, font: customFont, });
    // receiver address
    pages[3].drawText(detail.borrowerAddress || '', { x: 182, y: (height - 208), size: fontSize, font: customFont, });
    // HELOC account # (same value as the loan id)
    pages[3].drawText(detail.loanId || '', { x: 182, y: (height - 222), size: fontSize, font: customFont, });
    //#endregion

    //#region page 10 - acceptance signatures
    // receiver
    if (detail.borrowerSignature) {
        const pngImageBytes = await fetch(detail.borrowerSignature).then((res) => res.arrayBuffer());
        const pngImage = await pdfDoc.embedPng(pngImageBytes)
        const pngDims = pngImage.scale(0.25)
        pages[9].drawImage(pngImage, {
            x: 75,
            y: height - 381,
            width: pngDims.width,
            height: pngDims.height,
        })
    }
    if (detail.borrowerSignatureDate) {
        const md = moment(detail.borrowerSignatureDate);
        pages[9].drawText(md.format('MM'), { x: 296, y: (height - 381), size: fontSize, font: customFont, });
        pages[9].drawText(md.format('DD'), { x: 322, y: (height - 381), size: fontSize, font: customFont, });
        pages[9].drawText(md.format('YYYY'), { x: 348, y: (height - 381), size: fontSize, font: customFont, });
    }

    // co-signer / co-borrower
    pages[9].drawText(detail.coBorrowerName || '', { x: 75, y: (height - 476), size: fontSize, font: customFont, });

    if (detail.coBorrowerSignature) {
        const pngImageBytes = await fetch(detail.coBorrowerSignature).then((res) => res.arrayBuffer());
        const pngImage = await pdfDoc.embedPng(pngImageBytes);
        // only ~25pt between the "Name:" label and the signature line
        const pngDims = pngImage.scaleToFit(150, 24)
        pages[9].drawImage(pngImage, {
            x: 75,
            y: height - 516,
            width: pngDims.width,
            height: pngDims.height,
        })
    }
    if (detail.coBorrowerSignatureDate) {
        const md = moment(detail.coBorrowerSignatureDate);
        pages[9].drawText(md.format('MM'), { x: 292, y: (height - 516), size: fontSize, font: customFont, });
        pages[9].drawText(md.format('DD'), { x: 318, y: (height - 516), size: fontSize, font: customFont, });
        pages[9].drawText(md.format('YYYY'), { x: 344, y: (height - 516), size: fontSize, font: customFont, });
    }
    //#endregion

    const pdfBytes = await pdfDoc.save();

    const bytes = new Uint8Array(pdfBytes);
    const blob = new Blob([bytes], { type: "application/pdf" });
    return Promise.resolve(blob);
}

export default HeterIskaPDF;
